import { render, staticRenderFns } from "./RemoveGame.vue?vue&type=template&id=e66f692a&scoped=true&"
import script from "./RemoveGame.vue?vue&type=script&lang=js&"
export * from "./RemoveGame.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e66f692a",
  null
  
)

export default component.exports